import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWho = ['Women 35-60 noticing a "sudden" change in their midsection.', 'Those who feel "puffy" and inflamed regardless of what they eat.', 'Women struggling with the 3 AM "Stress Wake-up" and afternoon crashes.', 'Anyone tired of "punishing" their body with workouts that don\'t produce results.'];
const notForWho = ['Anyone looking for a "magic pill" or dangerous weight-loss stimulants.', 'Professional athletes or bodybuilders looking for "bulk."', 'Those unwilling to swap their morning black coffee for a nourishing routine.'];
export const WhoFor = () => {
  return <section className="py-24 bg-wellness-cream" data-id="element-141">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-142">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-143">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white p-8 md:p-12 rounded-3xl border border-wellness-sage/30 shadow-sm" data-id="element-144">
            <h3 className="text-3xl mb-8 text-wellness-forest flex items-center gap-3" data-id="element-145">
              <span className="italic" data-id="element-146">Who this is</span> For
            </h3>
            <ul className="space-y-6" data-id="element-147">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-4 font-sans font-light text-wellness-forest/80 leading-relaxed" data-id="element-148">
                  <CheckCircle2 className="w-6 h-6 text-wellness-sage shrink-0 mt-0.5" data-id="element-149" />
                  <span data-id="element-150">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-wellness-cream-dark p-8 md:p-12 rounded-3xl border border-wellness-forest/5" data-id="element-151">
            <h3 className="text-3xl mb-8 text-wellness-forest/60 flex items-center gap-3" data-id="element-152">
              <span className="italic" data-id="element-153">Who this is</span> Not For
            </h3>
            <ul className="space-y-6" data-id="element-154">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-4 font-sans font-light text-wellness-forest/60 leading-relaxed" data-id="element-155">
                  <XCircle className="w-6 h-6 text-wellness-forest/30 shrink-0 mt-0.5" data-id="element-156" />
                  <span data-id="element-157">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};